import React from 'react'
import Configurator from '../../configurator'

export default class Image extends Configurator {
    state = {
        exifOrientation: null,
    }

    /**
     * On image mounting set exif orientation state variable
     */
    setExifOrientation = () => {
        const { src } = this.props
        const client = new XMLHttpRequest()

        client.open('HEAD', src, true)
        const _that = this
        client.onreadystatechange = function() {
            if (this.readyState === this.HEADERS_RECEIVED) {
                const exif = JSON.parse(client.getResponseHeader('exif'))
                _that.setState({ exifOrientation: exif?.tags?.Orientation })
            }
        }
        client.send()
    }

    /**
     * on component mount call exif orientation state setter
     */
    componentDidMount() {
        this.setExifOrientation()
    }

    /**
     * Return true, if ext parameter is JPG or JPEG
     * @param {string} extension
     * @returns {boolean}
     */
    isJpeg = extension => {
        const ext = extension.toLowerCase()
        return ext === 'jpg' || ext === 'jpeg'
    }

    /**
     * Return true, if ext parameter is PNG
     * @param {string} extension
     * @returns {boolean}
     */
    isPng = extension => {
        const ext = extension.toLowerCase()
        return ext === 'png'
    }

    /**
     * Returns exif class string
     * @returns {string}
     */
    getExifClass = () => {
        const { src } = this.props
        const { exifOrientation } = this.state

        const extension = src?.substr(src?.lastIndexOf('.') + 1)

        if (!extension || !this.isJpeg(extension)) {
            return ''
        }

        return `exif-${exifOrientation}`
    }

    /**
     * Renders the component
     * @returns {*}
     */
    render = () => {
        const {
            src,
            defaultSrc,
            alt,
            title,
            className,
            style,
        } = this.props

        const extension = src?.substr(src?.lastIndexOf('.') + 1)
        const splitedSrc = src?.split('@')
        const nativeSrc = `${splitedSrc?.[0]}-native@${splitedSrc?.[1]}`

        return (
            <picture>
                <source srcSet={src} type="image/webp" />
                {extension && this.isJpeg(extension) && <source srcSet={nativeSrc} type="image/jpeg" />}
                {extension && this.isPng(extension) && <source srcSet={nativeSrc} type="image/png" />}
                <img
                    src={defaultSrc ? defaultSrc : src}
                    alt={alt || ''}
                    title={title}
                    className={`${className} ${this.getExifClass()}`}
                    style={style}
                />
            </picture>
        )
    }
}
